// extracted by mini-css-extract-plugin
export default {"cta":"kG-z","disabled":"lG-z"};